export default __webpack_public_path__ + "static/media/RakshabandanNew5.9cf604c3.png";